export default __webpack_public_path__ + "geburtstag-chat-01.08634592fca6a82d4462e10d4d537666.png";